import { render, staticRenderFns } from "./ChangeHomework.vue?vue&type=template&id=75764ef0&scoped=true"
import script from "./ChangeHomework.vue?vue&type=script&lang=js"
export * from "./ChangeHomework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75764ef0",
  null
  
)

export default component.exports